module.exports = __webpack_public_path__ + "img/erase-icon.34a04ec8.svg";